<script>
  import {onMount} from 'svelte'
  import {navigate} from 'svelte-routing'
  import Layout from '~/Components/Layout/Layout'

  export let activeContent = 'terms'

  const content = ({
    terms: {
      title: 'Terms and Conditions',
      content: '<p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p><p>Sumo alia splendide cum eu, vis sumo debitis patrioque id, at vel laoreet vivendum. Dicta euismod nec et, eos no suas erat offendit, vim quod alienum ne. Vix te iudico noster mandamus. Ei sonet verear qui, legendos petentium expetendis duo eu. An quo prodesset concludaturque. Illud volutpat dissentiet sea ex.</p><p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p>'
    }, 
    privacy: {
      title: 'Privacy Policy',
      content: '<p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p><p>Sumo alia splendide cum eu, vis sumo debitis patrioque id, at vel laoreet vivendum. Dicta euismod nec et, eos no suas erat offendit, vim quod alienum ne. Vix te iudico noster mandamus. Ei sonet verear qui, legendos petentium expetendis duo eu. An quo prodesset concludaturque. Illud volutpat dissentiet sea ex.</p><p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p>'
    },
    cookies: {
      title: 'Cookies',
      content: '<p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p><p>Sumo alia splendide cum eu, vis sumo debitis patrioque id, at vel laoreet vivendum. Dicta euismod nec et, eos no suas erat offendit, vim quod alienum ne. Vix te iudico noster mandamus. Ei sonet verear qui, legendos petentium expetendis duo eu. An quo prodesset concludaturque. Illud volutpat dissentiet sea ex.</p><p>Lorem ipsum dolor sit amet, per ea causae adipisci. Ius cu quod quodsi assueverit, id facer ubique posidonium quo. Volumus laboramus delicatissimi sea et. Cu sit pertinacia voluptatibus, per ei summo albucius, an partem utamur tamquam vix. Odio delicata similique pri ut, bonorum patrioque no nec, ei vide consul definitiones duo. Cum eu lorem ubique, viris veritus recteque at pri. Vide imperdiet te cum.</p>'
    }
  }[activeContent])

  onMount(() => {
    window.scrollTo(0, 0)
  })

</script>

<Layout>

  <div class="terms">

    <img class="terms__background" src="static/shapes/rectangle.svg" alt="">

    <h1 class="heading">{content.title}</h1>

    {@html content.content}

  </div>

  <div class="terms__contact">

    <img class="terms__contact-background top" src="static/shapes/rectangle.svg" alt="">

    <h3 class="heading">Any Further Questions?</h3>

    <p>For any further questions regarding our terms and conditions please do not hestiate to get in touch </p>

    <button class="terms__cta" on:click={() => navigate('/contact', {replace:true})}>Contact</button>

    <img class="terms__contact-background right" src="static/shapes/rectangle.svg" alt="">

    <img class="terms__contact-background right" src="static/shapes/rectangle.svg" alt="">

    <img class="terms__contact-background bottom" src="static/shapes/rectangle.svg" alt="">
    

  </div>

</Layout>

<style lang="scss">
  :global(.terms p){
    margin-bottom: 1rem;
    line-height: 1.875rem;
    font-size: 0.875rem;
  }
  
  .terms {

    padding: 3rem 0;
    position: relative;
    
     &__background {

      position: absolute;
      height: 50rem;
      width: 50rem;
      z-index: -10;
      top: -400px;
      left: -550px;
      transform: rotate(50deg);

     }

    .heading {

      max-width: 26rem;
      margin-bottom: 4rem;

    }

    &__contact {

      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4rem; 
      box-shadow: 0px 20px 80px rgba(21, 53, 43, 0.10);
      border-radius: 1.25rem;
      justify-content: center;
      background: white;
      position: relative;
      overflow: hidden;

      @media only screen and (max-width: 576px) {
        padding: 2rem;
      }

      &-background {
        position: absolute;
        height: 25rem;
        width: 25rem;
        &.top {
          left: 0;
          transform: translateX(-70%) rotate(10deg);
        }
        &.right {
          right: 0; 
          transform: translateX(70%) translateY(10%)  rotate(65deg);
        }
        &.bottom {
          right: 0;
          top: 0;
          transform: translateX(40%) translateY(40%)  rotate(55deg);
        }
      }

      p {

        margin-top: 1.5rem;
        margin-bottom: 2.5rem;
        font-size: 0.875rem;

      }

      button {

        background-color: var(--accent-colour);
        padding: 1.125rem 2.5rem;
        color: white;
        font-size: 1.125rem;
        font-weight: bold;
        border: none;
        border-radius: 2rem;

      }

    }
  }
</style>